import emailIconSrc from '@corbado/shared-ui/assets/email.svg';
import { memo, useRef } from 'react';
import React from 'react';
import { useIconWithTheme } from '../../../hooks/useIconWithTheme';
import { Icon } from './Icon';
export const EmailIcon = memo(props => {
    const svgRef = useRef(null);
    const { logoSVG } = useIconWithTheme(svgRef, emailIconSrc);
    return (React.createElement(Icon, { src: logoSVG, ref: svgRef, alt: 'expand-icon', ...props }));
});
